module.exports = __webpack_public_path__ + "static/img/nnn.460cdbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nnn.png
// module id = 9LUg
// module chunks = 2